import { createRootUrl } from '@proxies/index'

const GA_CONFIG = {
  'cocinas-tpc43': 'G-W8KTEZYKKH',
  'cocinas-tpcinternal': 'G-K07Q46PXLY',
  'cocinas-tpc': 'G-F5JT8M8XZJ',
  planificador3d: 'G-S0RKRB5CYN', // Nueva etiqueta para planificador3d.cocinas-tpc.com
} as const

const API_TO_GA_MAP: Record<string, string> = {
  'planificador3dapi.cocinas-tpc.com': 'G-S0RKRB5CYN',
  'cocinas-tpcinternalapi.for2home.com': 'G-K07Q46PXLY',
  'cocinas-tpc43api.for2home.com': 'G-W8KTEZYKKH',
  'h25api.for2home.com': 'G-F5JT8M8XZJ',
  'for2inspirationapi.for2home.com': 'G-F5JT8M8XZJ',
}

// ID adicional para planificador3d.cocinas-tpc.com
const PLANIFICADOR3D_GA_ID = 'G-S0RKRB5CYN'
const DEFAULT_GA_ID = 'G-F5JT8M8XZJ'

const isPlanificador3D = (): boolean => {
  const hostname = window.location.hostname
  const apiUrl = createRootUrl()

  if (hostname.includes('planificador3d.cocinas-tpc.com')) {
    return true
  }

  if (apiUrl.includes('planificador3dapi.cocinas-tpc.com')) {
    return true
  }

  return false
}

const loadGoogleAnalytics = (): void => {
  if (window.gtag || document.querySelector('script[src*="googletagmanager"]')) {
    return
  }

  // Cargar el script base de gtag.js (usamos el ID por defecto para la carga del script)
  const script = document.createElement('script')
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + DEFAULT_GA_ID
  script.async = true

  script.onload = () => {
    window.dataLayer = window.dataLayer || []
    function gtag() {
      window.dataLayer.push(arguments)
    }
    ;(window as any).gtag = gtag

    gtag('js', new Date())

    // const isDevelopment =
    //   window.location.hostname === 'localhost' && window.location.port === '9000'

    // Configurar el ID por defecto siempre
    // gtag('config', id) es la sintaxis correcta de Google Analytics
    // Primer argumento: 'config' (comando)
    // Segundo argumento: ID de tracking (string)
    // Tercer argumento (opcional): objeto con opciones de configuración
    gtag('config', DEFAULT_GA_ID)
    // if (isDevelopment) {
    //   console.log('[Google Analytics] ID por defecto configurado:', DEFAULT_GA_ID)
    // }

    // Si estamos en planificador3d.cocinas-tpc.com, configurar también el nuevo ID
    // Esto permite que ambos IDs reciban eventos simultáneamente
    if (isPlanificador3D()) {
      gtag('config', PLANIFICADOR3D_GA_ID)
      // if (isDevelopment) {
      //   console.log('[Google Analytics] ID adicional configurado:', PLANIFICADOR3D_GA_ID)
      //   console.log('Ambos IDs están activos para planificador3d')
      // }
    }

    initGA()
  }

  script.onerror = () => {
    console.error('❌ Error cargando Google Analytics')
  }

  document.head.appendChild(script)
}

export const getGAId = (): string => {
  const hostname = window.location.hostname
  const pathname = window.location.pathname
  const apiUrl = createRootUrl()

  // Logs para desarrollo - verificar configuración (comentados)
  // const isDevelopment = hostname === 'localhost' && window.location.port === '9000'
  // if (isDevelopment) {
  //   console.log('[Google Analytics] Verificando configuración...')
  //   console.log('Hostname:', hostname)
  //   console.log('API URL detectada:', apiUrl)
  // }

  for (const [api, gaId] of Object.entries(API_TO_GA_MAP)) {
    if (apiUrl.includes(api)) {
      // if (isDevelopment) {
      //   console.log('[Google Analytics] API detectada:', api)
      //   console.log('[Google Analytics] ID asignado:', gaId)
      //   console.log('Mapeo: API → GA_ID')
      //   console.log(` ${api} → ${gaId}`)
      // }
      return gaId
    }
  }

  if (isPlanificador3D()) {
    // if (isDevelopment) {
    //   console.log('[Google Analytics] Planificador3D detectado')
    //   console.log('[Google Analytics] ID asignado:', PLANIFICADOR3D_GA_ID)
    // }
    return PLANIFICADOR3D_GA_ID
  }

  for (const [key, gaId] of Object.entries(GA_CONFIG)) {
    if (hostname.includes(key) || pathname.includes(key)) {
      // if (isDevelopment) {
      //   console.log('[Google Analytics] Config detectado por hostname/pathname:', key)
      //   console.log('[Google Analytics] ID asignado:', gaId)
      // }
      return gaId
    }
  }

  const defaultId = GA_CONFIG['cocinas-tpc']
  // if (isDevelopment) {
  //   console.log('[Google Analytics] Usando ID por defecto:', defaultId)
  //   console.log('No se encontró mapeo específico para esta API/URL')
  // }
  return defaultId
}

export const getSiteVersion = (): string => {
  const hostname = window.location.hostname
  const pathname = window.location.pathname

  const version = Object.keys(GA_CONFIG).find(
    (key) => hostname.includes(key) || pathname.includes(key),
  )

  return version || 'default'
}

export const initGA = (): boolean => {
  if (typeof (window as any).gtag === 'undefined') {
    loadGoogleAnalytics()
    return false
  }

  const gaId = getGAId()
  const siteVersion = getSiteVersion()
  // const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '9000'

  try {
    // if (isDevelopment) {
    //   console.log('[Google Analytics] Inicializando...')
    //   console.log('[Google Analytics] ID principal:', gaId)
    //   console.log('[Google Analytics] Site Version:', siteVersion)
    // }

    // Configurar el ID principal según la URL
    // gtag('config', id, options) - sintaxis correcta de Google Analytics
    ;(window as any).gtag('config', gaId, {
      page_title: document.title,
      page_location: window.location.href,
      custom_map: {
        dimension1: 'site_version',
      },
    })

    // Si estamos en planificador3d, también enviar eventos al ID adicional :S
    if (isPlanificador3D()) {
      ;(window as any).gtag('config', DEFAULT_GA_ID, {
        page_title: document.title,
        page_location: window.location.href,
        custom_map: {
          dimension1: 'site_version',
        },
      })
      // if (isDevelopment) {
      //   console.log('[Google Analytics] ID adicional configurado en initGA:', DEFAULT_GA_ID)
      // }
    }

    ;(window as any).gtag('event', 'site_version', {
      site_version: siteVersion,
    })

    // if (isDevelopment) {
    //   console.log('[Google Analytics] Inicialización completada')
    //   console.log(
    //     'Los eventos se enviarán a:',
    //     isPlanificador3D() ? [gaId, DEFAULT_GA_ID] : [gaId],
    //   )
    // }

    return true
  } catch (error) {
    console.error('❌ Error inicializando Google Analytics:', error)
    return false
  }
}

export const trackPageView = (url: string): void => {
  if (typeof (window as any).gtag === 'undefined') {
    return
  }

  const gaId = getGAId()
  const pageViewConfig = {
    page_path: url,
    page_title: document.title,
    page_location: window.location.origin + url,
  }

  ;(window as any).gtag('config', gaId, pageViewConfig)

  if (isPlanificador3D() && gaId === PLANIFICADOR3D_GA_ID) {
    ;(window as any).gtag('config', DEFAULT_GA_ID, pageViewConfig)
  }
}

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number,
): void => {
  if (typeof (window as any).gtag !== 'undefined') {
    ;(window as any).gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

export const useAnalytics = () => {
  return {
    trackEvent,
    trackPageView,
    getGAId,
    getSiteVersion,
  }
}

if (typeof window !== 'undefined') {
  setTimeout(() => {
    loadGoogleAnalytics()
  }, 1000)
}

declare global {
  interface Window {
    gtag: (...args: any[]) => void
    dataLayer: any[]
  }
}
